import { DAYS } from '~shared/constants/days';
import { Button } from '~shared/shadcn/ui/button';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '~shared/shadcn/ui/dropdown-menu';

import {
  classDayFilterLabel,
  selectedClassDays,
  toggleClassDay,
} from '../lib/class-list-day-filter';

export function ClassDayFilter({
  value,
  onChange,
  className,
}: {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}) {
  const selected = new Set(selectedClassDays(value));

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant='outline' className={className}>
          {classDayFilterLabel(value)}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='start' className='w-40'>
        {DAYS.map((day) => (
          <DropdownMenuCheckboxItem
            key={day}
            checked={selected.has(day)}
            onSelect={(event) => {
              event.preventDefault();
            }}
            onCheckedChange={() => {
              onChange(toggleClassDay(value, day));
            }}
          >
            {day}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
